import { render, staticRenderFns } from "./ModusignWaitModal.vue?vue&type=template&id=79d5c3ee&"
import script from "./ModusignWaitModal.vue?vue&type=script&lang=js&"
export * from "./ModusignWaitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports